var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('svg',{style:(_vm.styles),attrs:{"width":_vm.width ? _vm.width : '20px',"height":_vm.height ? _vm.height : '20px'}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":'#' + _vm.name}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }